<nav class="navbar custom-navbar bg-faded main-header">
  <div class="dflex">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a
          title="View Menu"
          href="javascript:;"
          class="nav-link btnMenu"
          (click)="toggleSidebar.emit()"
        >
          <i class="hamburger-icon v2"> <span></span> </i>
        </a>
      </li>

      <li></li>
    </ul>
    <!-- <span class="navbar-heading hidden-xs-down">{{heading}} <i class="icon icon-arrows-right"></i>{{subheading}}</span>  -->

    <!-- <div style="cursor: pointer;">
    <button mat-mini-fab class="btnRefresh">
      <i
        class="material-icons"
        matTooltip="Refresh Page"
        (click)="refreshApp()"
      >
        refresh
      </i>
    </button>
  </div> -->
    <span class="navbar-heading hidden-xs-down">
      <span
        class="spanBreadcrumb"
        matTooltip="{{ heading }}"
        *ngIf="isdynamicHeading"
      >
        {{
          heading && heading.length > 40
            ? (heading | slice: 0 : 40) + ".."
            : heading
        }}</span
      >
      <!-- <span matTooltip="{{ dynamicHeading }}" *ngIf="!isdynamicHeading">
      {{
        dynamicHeading && dynamicHeading.length > 40
          ? (dynamicHeading | slice: 0:40) + ".."
          : dynamicHeading
      }}</span
    > -->
      <!-- <span> <i class="icon icon-arrows-right"></i></span>
   <span>{{subheading}}</span> -->
      <div
        class="breadcrumb-container"
        *ngIf="!isdynamicHeading && this.dynamicHeading"
      >
        <ng-container
          *ngFor="let part of dynamicHeading.split(' > '); let i = index"
        >
          <span
            class="clickable"
            [id]="'headingPart' + i"
            [ngClass]="{
              clickable:
                i === 1 &&
                dynamicHeading.split(' > ').length > 2 &&
                router.url !== parentPath,
              disabled: i === 1 && router.url === parentPath,
            }"
            (click)="
              dynamicHeading.split(' > ').length > 2
                ? onHeadingClick(i, part)
                : $event.preventDefault()
            "
          >
            {{ part }}
          </span>
          <span *ngIf="i < dynamicHeading.split(' > ').length - 1"> > </span>
        </ng-container>
      </div>
    </span>
    <span> </span> <span class="mr-auto"></span>
  </div>

  <div class="dflex">
    <div class="master-search" *ngIf="searchList && searchList.length > 0">
      <mat-icon
        (click)="getKeySearch(searchForm.value)"
        [matTooltip]="'SearchHeader.search' | translate"
        class="search-icon-magnify"
        >search</mat-icon
      >
      <input
        autofocus
        type="text"
        (ngModelChange)="isTyped = true"
        [placeholder]="'SearchHeader.placeholder' | translate"
        [(ngModel)]="searchValue"
        (focus)="showCloseIcon()"
        (keyup.enter)="getKeySearch(searchValue)"
      />
      <mat-icon
        class="search-icon-close"
        (click)="clearText()"
        [matTooltip]="'SearchHeader.collapse' | translate"
        *ngIf="isTyped"
        >close</mat-icon
      >
    </div>
    <div
      class="master-dropdown"
      [matMenuTriggerFor]="masterSearch"
      *ngIf="searchList && searchList.length > 0"
      (blur)="isVisible = false"
    >
      <mat-icon
        (click)="isVisible = true"
        style="line-height: 36px"
        [matTooltip]="'SearchHeader.expand' | translate"
        *ngIf="!isVisible && !isTyped"
      >
        arrow_drop_down</mat-icon
      >
      <mat-icon
        (click)="isVisible = false"
        style="padding-top: 20%"
        [matTooltip]="'SearchHeader.collapse' | translate"
        *ngIf="isVisible && !isTyped"
      >
        arrow_drop_up</mat-icon
      >
    </div>
    <mat-menu
      class="menu-master"
      xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
      #masterSearch="matMenu"
    >
      <div>
        <form
          #searchForm="ngForm"
          class="master-search-form"
          (ngSubmit)="setSearch(searchForm.value)"
        >
          <div
            (click)="$event.stopPropagation()"
            (keydown.tab)="$event.stopPropagation()"
            *ngFor="let search of searchList; let p_index = index"
            class="search-content-row"
          >
            <div
              *ngFor="let control of search.controls; let c_index = index"
              class="search-col search-col-{{ control.column }}"
              [ngClass]="{ 'opd-adt-module': this.isDatepicker == true }"
            >
              <mat-radio-group
                *ngIf="control.type == 'radio'"
                [(ngModel)]="this[control.name]"
                name="{{ control.name }}"
              >
                <mat-radio-button
                  *ngFor="let radio of control.radios; let r_index = index"
                  value="{{ radio.value }}"
                  (click)="radioOnClick(radio)"
                  >{{ radio.text }}</mat-radio-button
                >
              </mat-radio-group>

              <mat-form-field
                *ngIf="control.type == 'date'"
                appearance="outline"
              >
                <mat-label>{{ control.placeholder }}</mat-label>

                <input
                  matInput
                  [matDatepicker]="picker"
                  [min]="minDate"
                  [max]="control.isTodaysDate ? maxDate : ''"
                  placeholder="{{ control.placeholder }}"
                  [(ngModel)]="this[control.name]"
                  value="{{ control.value }}"
                  name="{{ control.name }}"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <!-- <input type="text" placeholder="Select From Date - To Date" ngxDaterangepickerMd [(ngModel)]="selected"
                matInput [ranges]="ranges" [alwaysShowCalendars]="true" [linkedCalendars]="true"
                [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }" /> -->
              </mat-form-field>

              <div
                class="custom-form-field"
                *ngIf="control.type == 'dateRange'"
              >
                <label
                  class="custom-dateRange-label"
                  [ngClass]="{ floating: selected1 || dateInput?.value }"
                >
                  {{ control.placeholder }}
                </label>
                <div class="custom-input-container">
                  <input
                    type="text"
                    #dateInput
                    ngxDaterangepickerMd
                    [lockStartDate]="false"
                    placeholder=""
                    [(ngModel)]="selected1"
                    matInput
                    [ranges]="ranges"
                    [alwaysShowCalendars]="true"
                    [linkedCalendars]="true"
                    [showClearButton]="true"
                    autocomplete="off"
                    [locale]="{
                      applyLabel: applyLabel,
                      clearLabel: clearLabel,
                      format: 'DD/MM/YYYY',
                      monthNames: monthsArr,
                      daysOfWeek: daysArr,
                    }"
                    name="daterange"
                    (change)="fixEndDate()"
                    (ngModelChange)="onDateRangeSelected($event)"
                  />
                </div>
              </div>

              <!-- <mat-form-field *ngIf="control.type == 'dateRange'" appearance="outline">
              <mat-label>{{ control.placeholder }}</mat-label>
            
              <input
                type="text"
                ngxDaterangepickerMd
                placeholder="{{ control.placeholder }}"
                [(ngModel)]="selected1"
                matInput
                [ranges]="ranges"
                [alwaysShowCalendars]="true"
                [linkedCalendars]="true"
                [showClearButton]="true"
                autocomplete="off"
                [locale]="dateRangeLocale"
                name="daterange"
              />
            </mat-form-field> -->
              <div *ngIf="error.isError" class="alert alert-danger">
                {{ error.errorMessage }}
              </div>

              <mat-form-field
                *ngIf="control.type == 'text'"
                appearance="outline"
              >
                <mat-label>{{ control.placeholder }}</mat-label>

                <input
                  matInput
                  placeholder="{{ control.placeholder }}"
                  [(ngModel)]="this[control.name]"
                  name="{{ control.name }}"
                />
              </mat-form-field>

              <mat-form-field
                *ngIf="control.type == 'number'"
                appearance="outline"
              >
                <mat-label>{{ control.placeholder }}</mat-label>

                <input
                  type="number"
                  matInput
                  placeholder="{{ control.placeholder }}"
                  [(ngModel)]="this[control.name]"
                  name="{{ control.name }}"
                  value="{{ control.value }}"
                />
              </mat-form-field>

              <mat-form-field
                *ngIf="control.type == 'select'"
                appearance="outline"
              >
                <mat-label>{{ control.placeholder }}</mat-label>

                <mat-select
                  id="{{ control.name }}"
                  placeholder="{{ control.placeholder }}"
                  [(ngModel)]="this[control.name]"
                  name="{{ control.name }}"
                  (selectionChange)="selectOnChange(control.name, $event.value)"
                  value="{{ control.value }}"
                  (focus)="selectOnClick(control, p_index, c_index)"
                >
                  <mat-option>
                    <input
                      id="searchAutoComplete"
                      class="search-select-box"
                      (click)="$event.stopPropagation()"
                      (keyup)="dropdownOnSearch(control, $event)"
                      (keydown.space)="$event.stopPropagation()"
                      type="text"
                      [placeholder]="'RegistrationPage.search' | translate"
                      value="{{ control.searchValue }}"
                    />
                  </mat-option>
                  <mat-option [value]="">{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>
                  <div *ngIf="control.name == 'unit'">
                    <mat-option
                      *ngFor="let option of control.options"
                      [value]="option.id"
                    >
                      {{ option.desc }}
                    </mat-option>
                  </div>
                  <div *ngIf="control.name != 'unit'">
                    <mat-option
                      *ngFor="let option of control.options"
                      [value]="option"
                    >
                      {{ option.desc }}
                    </mat-option>
                  </div>
                  <!-- <ng-container *ngFor="let option of control.options">
                    <option *ngIf="[control.name]=='unit'"  [ngValue]="option.id" >{{ option.desc }}</option>
                    <option *ngIf="[control.name]!='unit'"  [ngValue]="option" >{{ option.desc }}</option>
                </ng-container>                -->
                </mat-select>
              </mat-form-field>

              <mat-form-field
                *ngIf="control.type == 'selectText'"
                appearance="outline"
              >
                <mat-label>{{ control.placeholder }}</mat-label>

                <mat-select
                  id="{{ control.name }}"
                  placeholder="{{ control.placeholder }}"
                  [(ngModel)]="this[control.name]"
                  method="POST"
                  name="{{ control.name }}"
                  (selectionChange)="selectOnChange(control.name, $event.value)"
                  value="{{ control.value }}"
                >
                  <mat-option>
                    <input
                      id="searchAutoComplete"
                      class="search-select-box"
                      (click)="$event.stopPropagation()"
                      (keyup)="dropdownSearch(control, $event)"
                      (keydown.space)="$event.stopPropagation()"
                      type="text"
                      [placeholder]="'RegistrationPage.search' | translate"
                      value="{{ control.searchValue }}"
                    />
                  </mat-option>
                  <mat-option [value]="">{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>
                  <div *ngIf="control.name == 'unit'">
                    <mat-option
                      *ngFor="let option of control.options"
                      [value]="option.id"
                    >
                      {{ option.desc }}
                    </mat-option>
                  </div>
                  <div *ngIf="control.name != 'unit'">
                    <mat-option
                      *ngFor="let option of control.options"
                      [value]="option"
                    >
                      {{ option.desc }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>

              <mat-form-field
                *ngIf="control.type == 'selectDoc'"
                appearance="outline"
              >
                <mat-label>{{ control.placeholder }}</mat-label>

                <mat-select
                  id="{{ control.name }}"
                  placeholder="{{ control.placeholder }}"
                  [(ngModel)]="this[control.name]"
                  name="{{ control.name }}"
                  (selectionChange)="selectOnChange(control.name, $event.value)"
                  value="{{ control.value }}"
                  (focus)="selectOnClickDoc(control, p_index, c_index)"
                >
                  <mat-option>
                    <input
                      id="searchAutoComplete"
                      class="search-select-box"
                      (click)="$event.stopPropagation()"
                      (keyup)="dropdownOnSearch(control, $event)"
                      type="text"
                      [placeholder]="'RegistrationPage.search' | translate"
                      value="{{ control.searchValue }}"
                    />
                  </mat-option>
                  <mat-option [value]="">{{
                    "RegistrationPage.none" | translate
                  }}</mat-option>
                  <div *ngIf="control.name == 'unit'">
                    <mat-option
                      *ngFor="let option of control.options"
                      [value]="option.id"
                    >
                      {{ option.desc }}
                    </mat-option>
                  </div>
                  <div *ngIf="control.name != 'unit'">
                    <mat-option
                      *ngFor="let option of control.options"
                      [value]="option"
                    >
                      {{ option.desc }}
                    </mat-option>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="search-content-row">
            <div class="search-col search-col-6">
              <div
                (keydown.tab)="$event.stopPropagation()"
                (click)="$event.stopPropagation()"
              >
                <mat-checkbox name="checkbox_filter" [(ngModel)]="saveFilter">{{
                  "SearchHeader.saveSearch" | translate
                }}</mat-checkbox>
              </div>
            </div>
            <div class="search-col search-col-6 right">
              <button
                type="submit"
                class="btn-master-search"
                mat-button
                [matTooltip]="'SearchHeader.search' | translate"
              >
                <mat-icon>search</mat-icon>
              </button>
              <button
                type="button"
                class="btn-master-cancel"
                mat-button
                (click)="$event.stopPropagation(); clearSearch()"
                [matTooltip]="'SearchHeader.reset' | translate"
              >
                <mat-icon>refresh</mat-icon>
              </button>
            </div>
          </div>
        </form>
      </div>
    </mat-menu>

    <mat-icon
      *ngIf="showQRScanButton"
      class="color-white menuModules mx-2"
      matTooltip="Scan QR Code"
      (click)="openBarcodeScanDialog()"
    >
      center_focus_weak
    </mat-icon>

    <mat-icon
      *ngIf="showQRScanButton && isAiImageSearch"
      class="color-white menuModules mx-2"
      matTooltip="Image search"
      (click)="openCameraDialog()"
    >
      perm_identity
    </mat-icon>

    <!-- HERE -->
    <mat-icon
      matTooltip="Menu"
      [matMenuTriggerFor]="menu"
      class="color-white menuModules mx-2"
      >apps</mat-icon
    >

    <mat-icon
      matTooltip="Search"
      (click)="goToSearchPage()"
      class="color-white menuModules mx-2"
      >search</mat-icon
    >
    <mat-menu
      #menu="matMenu"
      class="mat-menu-modal"
      xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
    >
      <div class="mat-menu-modal menu-modal-list">
        <mat-form-field
          appearance="outline"
          class="full-width"
          (click)="$event.stopPropagation()"
          style="padding: 0 !important"
        >
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            placeholder="Search"
            [(ngModel)]="searchModule"
            (input)="onSearchModuleChange()"
            (click)="$event.stopPropagation()"
          />
        </mat-form-field>
        <div *ngFor="let module of filteredModuleList">
          <ng-container *ngIf="module.menuList.length > 0">
            <span class="category-name">{{ module.moduleName }}</span>
            <div class="menu-content-row" *ngFor="let menu of module.menuList">
              <ng-container *ngFor="let submenu of menu.list">
                <div class="search-col search-col-3 center">
                  <div class="menu-item" (click)="menuOnClick(submenu)">
                    <img src="{{ submenu.image }}" />
                    <span>{{ submenu.name }}</span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </mat-menu>

    <mat-icon
      matTooltip="Notification"
      [matMenuTriggerFor]="notification"
      class="color-white menuModules mx-2"
    >
      notifications
    </mat-icon>
    <span class="spanNotificationCount" *ngIf="pushNotificationCount > 0">{{
      pushNotificationCount
    }}</span>
    <mat-menu
      #notification="matMenu"
      class="mat-menu-modal"
      xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
    >
      <div (click)="$event.stopPropagation()">
        <app-push-notification-list></app-push-notification-list>
      </div>
    </mat-menu>
    <img
      src="./assets/images/light-emergency-on.png"
      alt="image"
      style="height: 20px; margin-right: 10px; cursor: pointer"
      (click)="onEmergencyOn()"
    />
    <!-- 
  <mat-icon
    *ngIf="isCounterFlg"
    matTooltip="Cash Counter"
    [matMenuTriggerFor]="cashCounter"
    class="color-white menuModules ml-15 span-flex"
  >
    account_circle
  </mat-icon> -->
    <mat-menu
      #cashCounter="matMenu"
      class="mat-menu-modal"
       xPosition="before"
      yPosition="above"
      [overlapTrigger]="false"
    >
      <app-cash-counter></app-cash-counter>
    </mat-menu>

    <!-- <mat-icon [matMenuTriggerFor]="menuUser" class="color-white menuUserSettings ml-15">person</mat-icon> -->
    <div
      [matMenuTriggerFor]="menuUser"
      matTooltip="{{ userTypeName }} ({{ unitName }})"
      class="color-white menuUserSettings ml-15 span-flex"
    >
      <img
        *ngIf="userImage"
        alt=""
        [src]="userImage"
        class="color-white img-round userImageClick span-inline"
      />
      <img
        *ngIf="!userImage"
        alt=""
        [src]="imageUrl ? imageUrl : './assets/images/user-black.png'"
        class="userImageClick"
      />
      <span class="span-inline">
        <span>{{ loginName }}</span> <br />
        <span class="span-unit"
          >{{ "procurement.UNIT" | translate }}:
          {{ unitCode ? unitCode : unitCodeValue }}</span
        >
      </span>
      <mat-icon class="profile-down-arrow">keyboard_arrow_down</mat-icon>
    </div>
    <!-- <img src="../assets/images/user.png" [matMenuTriggerFor]="menuUser" class="color-white menuUserSettings ml-15"> -->
    <mat-menu
      #menuUser="matMenu"
      class="mat-menu-modal menuUserProfile"
      yPosition="above"
      [overlapTrigger]="false"
      (closed)="onMenuClose()"
      style="background-color: #71fafa1a"
    >
      <div class="divProfile">
        <div class="imgProfile">
          <img
            *ngIf="!userImage"
            class="img-round"
            [src]="imageUrl ? imageUrl : './assets/images/user-black.png'"
          />
          <img *ngIf="userImage" class="img-round" [src]="userImage" />
        </div>
        <div class="userProfileDetails">
          <div class="name">{{ loginName }}</div>
          <div class="unit">
            {{
              orgDesc?.length > 35 ? (orgDesc | slice: 0 : 35) + "..." : orgDesc
            }}
          </div>
          <div class="unit">{{ userTypeName }}</div>
        </div>
        <div class="userProfileUpdate cursorPointer">
          <!-- <mat-icon
          class="pull-right icon-edit-profile"
          matTooltip="Update"
          (click)="openProfileDialog()"
          >create
        </mat-icon> -->
        </div>
      </div>

      <div>
        <div>
          <div class="organization">Hi, {{ loginName?.split(" ")[0] }}</div>
          <!-- <mat-form-field
          class="full-width"
          (click)="$event.stopPropagation()"
          appearance="outline"
        >
          <mat-label>Organization</mat-label>
          <mat-select [(ngModel)]="masterHeaderOrg" name="org" (selectionChange)="orgChanged(masterHeaderOrg)">
            <mat-option *ngFor="let org of orgs" [value]="org">{{
              org.orgCode
            }}</mat-option>
          </mat-select>
        </mat-form-field> -->
        </div>
        <div class="mt-10">
          <mat-form-field
            class="full-width"
            (click)="$event.stopPropagation()"
            appearance="outline"
          >
            <mat-label>{{ "procurement.Unit" | translate }} </mat-label>
            <mat-select
              [(ngModel)]="masterHeaderUnit"
              name="unit"
              (selectionChange)="unitChanged(masterHeaderUnit)"
            >
              <mat-option
                *ngFor="let unit of orgUnits"
                [value]="unit.unitCode"
                >{{ unit.unitName }}</mat-option
              >
            </mat-select>
          </mat-form-field>
        </div>
        <!-- <div class="mt-10">
        <mat-form-field
          class="full-width"
          (click)="$event.stopPropagation()"
          appearance="outline"
          >
          <mat-label>Room</mat-label>
          <mat-select [(ngModel)]="masterRoomData" name="room" (selectionChange)="changeUnitRoom(masterRoomData)">
          <mat-option *ngFor="let room of rooms" [value]="room.desc">{{
          room.desc
          }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div> -->
        <div class="mt-10" *ngIf="storeList && storeList.length > 0">
          <mat-form-field
            class="full-width"
            (click)="$event.stopPropagation()"
            appearance="outline"
          >
            <mat-label>Store</mat-label>
            <mat-select [(ngModel)]="masterHeaderStore" name="store">
              <mat-option *ngFor="let store of storeList" [value]="store">{{
                store.storeDesc
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div
          class="mt-15"
          *ngIf="
            (cashCounterList && cashCounterList.length > 0) ||
            masterHeaderCashCounter
          "
          style="display: flex"
        >
          <mat-form-field
            class="custom-width"
            (click)="$event.stopPropagation()"
            appearance="outline"
          >
            <mat-label>Cash Counter</mat-label>
            <input
              matInput
              [value]="cashCounterName"
              [disabled]="isDisabled"
              *ngIf="masterHeaderCashCounter"
            />
            <input
              matInput
              [value]="'Counter Not Selected'"
              [disabled]="isDisabled"
              *ngIf="!masterHeaderCashCounter"
            />
          </mat-form-field>
          &nbsp;
          <button
            (click)="openCashCounter()"
            mat-mini-fab
            class="btnAction btnChange btnBlue"
            matTooltip="Edit Cash Counter"
          >
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div class="mt-10">
          <div style="display: flex; margin-left: 15px" *ngIf="workstationName">
            <div class="unit">Workstation</div>
            &nbsp;&nbsp;
            <div
              style="
                width: 10px;
                height: 10px;
                border-radius: 14px;
                background: rgb(4, 238, 176);
                align-self: center;
              "
            ></div>
            &nbsp;
            <div class="unit">{{ workstationName }}</div>
          </div>
        </div>
        <div class="mt-10">
          <div style="justify-items: anchor-center; text-align: -webkit-center">
            <mat-chip-listbox
              *ngIf="showLanguages"
              class="language-chip-list"
              aria-label="Available Languages"
            >
              <mat-chip-option
                style="width: 100px"
                *ngFor="let lang of languageList"
                [selected]="lang.code === selected"
                (click)="selectLanguage(lang); $event.stopPropagation()"
              >
                {{ lang.desc }}
              </mat-chip-option>
            </mat-chip-listbox>
          </div>
        </div>
        <div class="mt-10 center">
          <button
            (click)="showLanguages = true; $event.stopPropagation()"
            mat-mini-fab
            class="btnAction btnLang"
            matTooltip="Change Language"
          >
            <img
              src="./assets/images/translator.png"
              alt="Change"
              style="width: 35px !important; height: 35px !important"
            />
          </button>
          &nbsp;
          <button
            (click)="changeSettings()"
            mat-mini-fab
            class="btnAction btnChange"
            matTooltip="Switch"
          >
            <img
              src="./assets/images/switch.png"
              alt="Change"
              style="width: 35px !important; height: 35px !important"
            />
          </button>
          &nbsp;
          <button
            (click)="openSettingsDialog()"
            mat-mini-fab
            class="btnAction btnKey"
            matTooltip="Key Settings"
          >
            <img
              src="./assets/images/lock.png"
              alt="Key Settings"
              style="width: 35px !important; height: 35px !important"
            />
          </button>
          &nbsp;
          <button
            (click)="signout()"
            mat-mini-fab
            class="btnAction btnLogout"
            matTooltip="Logout"
          >
            <img
              src="./assets/images/power-button.png"
              alt="Logout"
              style="width: 45px !important; height: 45px !important"
            />
          </button>
        </div>
      </div>
    </mat-menu>
  </div>
</nav>
